import {FilterMatchMode, FilterOperator} from "primereact/api";
import {AUDIO_LOADING, CLEAR_ALL_STATES, UPLOAD_AUDIO_LOADING} from "../types/types";
import {GET_AUDIO_URL} from "../types/typesMonitoringList";
import {
    CLEAR_QUALITY_CONTROL_STATISTICS_FILTERS,
    GET_QUALITY_CONTROL_STATISTIC,
    GET_QUALITY_CONTROL_STATISTICS,
    GET_QUALITY_CONTROL_STATISTICS_PAGINATION,
    INITIAL_QUALITY_CONTROL_STATISTICS_DATA,
    SELECTED_QUALITY_CONTROL_STATISTICS_ID,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_PAGE,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_SIZE,
    SET_QUALITY_CONTROL_RATED_QUESTIONNAIRES,
    SET_QUALITY_CONTROL_STATISTICS_FILTER,
    SET_QUALITY_CONTROL_STATISTICS_FIRST_PAGE,
    SET_QUALITY_CONTROL_STATISTICS_LOADING,
    SHOW_QUALITY_CONTROL_STATISTICS_DETAIL_LOADING,
    UPDATE_QUALITY_CONTROL_STATISTICS_FILTER,
    SHOW_EXPORT_QUALITY_CONTROL_STATISTICS_LOADING,
    GET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY,
    SET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY_LOADER,
    GET_QUALITY_CONTROL_STATISTICS_FILES_PAGINATION,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_PAGE,
    SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_SIZE,
} from "../types/typesQualityControlStatistics";

const emptyContainsFilter = {
    operator: FilterOperator.AND,
    constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
};

const emptyInFilter = {value: null, matchMode: FilterMatchMode.IN};

const createClearFilters = () => ({
    qualityControlStatus: {...emptyInFilter},
    qualityControlId: {...emptyInFilter},
    qualityControlName: {...emptyInFilter},
    start: {...emptyInFilter},
    fullName: {...emptyInFilter},
    ani: {...emptyContainsFilter},
    aNumber: {...emptyContainsFilter},
    ownerUserName: {...emptyContainsFilter},
    ownerType: {...emptyInFilter},
    forcedClosing: {...emptyInFilter},
    campaignFullName: {...emptyInFilter},
    branchId: {...emptyInFilter},
    queueFullName: {...emptyInFilter},
    status: {...emptyInFilter},
    callType: {...emptyInFilter},
    direction: {...emptyInFilter},
    evaluationScore: {...emptyContainsFilter},
    score: {...emptyContainsFilter},
    evaluationUserName: {...emptyContainsFilter},
    createdByUserFullName: {...emptyContainsFilter},
    evaluationDate: {...emptyInFilter},
    isManual: {...emptyInFilter},
    controlEnd: {...emptyInFilter},
    duration: {...emptyInFilter},
    fullCallDuration: {...emptyInFilter},
    end: {...emptyInFilter},
});

const initialStatisticData = {
    duration: null,
    phoneNo: null,
    contactName: null,
    description: null,
    url: null,
    end: null,
    id: null,
    campaignId: null,
    campaignName: null,
    nameFrom: null,
    nameTo: null,
    status: null,
    typeChannel: null,
    start: null,
    direction: null,
    isDeclined: false,
    username: null,
    hasDetails: false,
    sessionId: null,
    amdHangup: null,
    callReset: null,
    evaluationScore: null,
    evaluationUserName: null,
    evaluationDate: null,
    audioControlId: null,
    audioControlName: null,
    qualityControlId: null,
    qualityControlName: null,
    qualityControlStatus: null,
    manualEvaluation: null,
    aiEvaluation: null,
    transcription: null,
};

const initialState = {
    selectedStatisticId: null,
    clearFilters: createClearFilters(),
    statisticsList: [],
    pagination: {
        hasNext: 0,
        pageNumber: 0,
        countPage: 0,
        totalItems: 0,
    },
    paginationPage: 1,
    paginationSize: 10,
    statisticData: initialStatisticData,
    audioUrl: null,
    audioUrlLoading: false,
    audioUrlUploadLoading: false,
    loading: false,
    exportLoading: false,
    detailsLoading: false,
    error: false,
    pageChanged: false,
    statisticFilterData: null,
    filesHistory: [] as any[],
    filesHistoryLoader: false,
    filesPagination: {
        hasNext: 0,
        pageNumber: 0,
    },
    filesPaginationPage: 1,
    filesPaginationSize: 10,
    ratedQuestionnaires: [] as {
        id: number;
        name: string;
        status: number | null;
        statusLabel: string;
        statusBadgeClassName: string;
        searchLabel: string;
        score: number | null;
        isManual: boolean | null;
        userFullName: string | null;
        dateTimeEnd: string | null;
    }[],
}

export const QualityControlStatisticsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SELECTED_QUALITY_CONTROL_STATISTICS_ID:
            return {...state, selectedStatisticId: action.payload}
        case CLEAR_QUALITY_CONTROL_STATISTICS_FILTERS:
            return {...state, clearFilters: createClearFilters()}
        case GET_QUALITY_CONTROL_STATISTICS:
            return {...state, statisticsList: action.payload}
        case GET_QUALITY_CONTROL_STATISTICS_PAGINATION:
            return {
                ...state,
                pagination: {
                    hasNext: action.payload.hasNext,
                    pageNumber: action.payload.pageNumber,
                    countPage: action.payload.countPage,
                    totalItems: action.payload.totalItems,
                }
            }
        case SET_CURRENT_QUALITY_CONTROL_STATISTICS_PAGE:
            return {...state, paginationPage: action.payload}
        case SET_CURRENT_QUALITY_CONTROL_STATISTICS_SIZE:
            return {...state, paginationSize: action.payload}
        case GET_QUALITY_CONTROL_STATISTIC:
            return {...state, statisticData: action.payload}
        case SET_QUALITY_CONTROL_STATISTICS_LOADING:
            return {...state, loading: action.payload}
        case SHOW_EXPORT_QUALITY_CONTROL_STATISTICS_LOADING:
            return {...state, exportLoading: action.payload}
        case GET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY:
            return {...state, filesHistory: Array.isArray(action.payload) ? [...action.payload] : []}
        case SET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY_LOADER:
            return {...state, filesHistoryLoader: action.payload}
        case GET_QUALITY_CONTROL_STATISTICS_FILES_PAGINATION:
            return {...state, filesPagination: {hasNext: action.payload.hasNext, pageNumber: action.payload.pageNumber}}
        case SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_PAGE:
            return {...state, filesPaginationPage: action.payload}
        case SET_CURRENT_QUALITY_CONTROL_STATISTICS_FILES_SIZE:
            return {...state, filesPaginationSize: action.payload}
        case INITIAL_QUALITY_CONTROL_STATISTICS_DATA:
            return {...state, statisticData: initialStatisticData, ratedQuestionnaires: []}
        case SET_QUALITY_CONTROL_RATED_QUESTIONNAIRES:
            return {...state, ratedQuestionnaires: action.payload}
        case CLEAR_ALL_STATES:
            return initialState
        case SHOW_QUALITY_CONTROL_STATISTICS_DETAIL_LOADING:
            return {...state, detailsLoading: action.payload}
        case GET_AUDIO_URL:
            return {...state, audioUrl: action.payload}
        case AUDIO_LOADING:
            return {...state, audioUrlLoading: action.payload}
        case UPLOAD_AUDIO_LOADING:
            return {...state, audioUrlUploadLoading: action.payload}
        case SET_QUALITY_CONTROL_STATISTICS_FIRST_PAGE:
            return {...state, pageChanged: !state.pageChanged}
        case SET_QUALITY_CONTROL_STATISTICS_FILTER:
            return {...state, statisticFilterData: action.payload}
        case UPDATE_QUALITY_CONTROL_STATISTICS_FILTER: {
            const {field, value} = action.payload;
            // @ts-ignore
            const currentFilter = state.clearFilters[field];

            if (!currentFilter) return state;

            let updatedField;

            if ('constraints' in currentFilter) {
                updatedField = {
                    ...currentFilter,
                    constraints: [
                        {
                            ...currentFilter.constraints[0],
                            value: value
                        }
                    ]
                };
            } else {
                updatedField = {
                    ...currentFilter,
                    value: value
                };
            }

            return {
                ...state,
                clearFilters: {
                    ...state.clearFilters,
                    [field]: updatedField
                }
            };
        }
        default:
            return state
    }
}
